import api from './api'
import C from './config'
import M from './common'

// let lib = { C, M};
export default  {api,C,M}



// WEBPACK FOOTER //
// ./src/lib/lib.js